import React, { useEffect, useRef, useState } from "react";
import Checkbox from "../CheckBox";
import * as Styled from "./styles";
import { TError } from "Services/Error/error";
import TextInput from "Components/Form/Inputs/Text";
import { useFilters } from "Contexts/FiltersContext";
import { set } from "immutable";

export interface IOptions {
  id: string | number;
  name: string;
  subvalue?: string;
  qty?: number;
}

interface Props {
  label?: string;
  placeholder?: string;
  search?: string;
  setSearch?(text: string): void;
  selected: any[];
  setSelected(selected: any): void;
  options: IOptions[];
  showQty?: boolean;
  hideSearch?: boolean;
  error?: TError;
  newSearch?: boolean;
}

const CheckboxSearch: React.FC<Props> = ({
  label,
  placeholder,
  search,
  setSearch,
  selected = [],
  setSelected,
  options = [],
  showQty = false,
  hideSearch,
  newSearch = false,
  error = {
    status: false,
    message: "",
  },
}) => {
  const isSelected = (option: IOptions) =>
    selected.filter(item => item.id === option.id).length > 0;
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState(0);
  const { registerResetFn } = useFilters();

  function select(key: number | string) {
    const index = options.findIndex(op => op.id == key);
    if (index !== -1) {
      const option = { ...options[index], indice: index };
      isSelected(option)
        ? setSelected(selected.filter(item => item.id != option.id))
        : setSelected([...selected, option]);
    }
  }

  useEffect(() => {
    registerResetFn(() => {
      setSelected([]); // essa função será chamada pelo Filters
      setSearch && setSearch("");
    });
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      if (!hideSearch) {
        // Expand: calcula a altura real do conteúdo
        setMaxHeight(contentRef.current.scrollHeight);
      } else {
        // Collapse
        setMaxHeight(0);
      }
    }
  }, [hideSearch]);

  return (
    <Styled.Container hideSearch={hideSearch} maxHeight={maxHeight}>
      <div ref={contentRef} style={{ margin: "1px" }}>
        <TextInput
          defaultValue={search}
          change={setSearch}
          placeholder={placeholder}
          newSearch={newSearch}
        />

        {!error.status ? (
          <Styled.Options>
            {options.map(option => (
              <div key={`option-${option.id}`}>
                <Checkbox
                  defaultValue={isSelected(option)}
                  change={() => select(option.id)}
                  checked={isSelected(option)}
                >
                  {option.name}
                </Checkbox>
              </div>
            ))}
          </Styled.Options>
        ) : (
          <Styled.ErrorMessage>{error.message}</Styled.ErrorMessage>
        )}
      </div>
    </Styled.Container>
  );
};

export default CheckboxSearch;
